<script>
    const axios = require('axios');

    export default {

      props: [
        'timer',
        'showOnlyOnce',
        'popupId',
        'modalId',
      ],

      methods: {
        openPopup() {

          $(this.modalId).modal('show')

          if (this.showOnlyOnce) {
            window.localStorage.setItem('popup-' + this.popupId, true)
          }
        },

        closePopup() {
          $(this.modalId).modal('hide')
        }
      },

      mounted() {
        if (this.showOnlyOnce === 'true' && window.localStorage.getItem('popup-' + this.popupId) !== null) {
          return;
        }

        var self = this;
        setTimeout(function() { self.openPopup() }, this.timer * 1000);
      }
    }
    
</script>
